module.exports = __webpack_public_path__ + "media/images/faces/user-5d9ea6317191df85e1b9da1139a45de3.jpeg";